angular.module('MyApp')
    .service('AtividadesComplementaresService', ["Configs", "$resource", "$q" , "$http", function (Configs, $resource, $q, $http) {

        let methodGetObject= { cache: false, query: { method: 'GET', isArray: false } }
        let methodGetArray = { cache: false, query: { method: 'GET', isArray: true } }
        
        this.obterAtividades = function(aluno = {}) {
            let deferr = $q.defer();

            let objQuery       = {};
            objQuery.idPessoa  = aluno.id;
            objQuery.idAluno   = aluno.codAluno;

            if (aluno.codAluno && aluno.id) {
                $resource(Configs.getApiServer() + '/matricula/listar-atividades-complementares', {}, methodGetObject)
                .query(objQuery, function (response) {
                    deferr.resolve(response);
                }, function (response) {
                    deferr.reject();
                });
            } else {
                deferr.resolve(false);
            }

            return deferr.promise;
        }

        this.obterAtividadesPorTipo = function(aluno = {}) {
            let deferr = $q.defer();

            let objQuery       = {};
            objQuery.idAluno   = aluno.codAluno;
            objQuery.idPessoa  = aluno.id;

            if (aluno.codAluno && aluno.id) {
                $resource(Configs.getApiServer() + '/matricula/listar-atividades-complementares-exigiveis', {}, methodGetArray)
                .query(objQuery, function (response) {
                    deferr.resolve(response);
                }, function (response) {
                    deferr.reject();
                });
            } else {
                deferr.resolve(false);
            }

            return deferr.promise;
        }

    }]);